// AI Generated Component
import { Component, OnInit } from '@angular/core';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { SourceCodeExcludesApiService } from '../../services/source-code-excludes-api.service';
import { SourceCodeExcludesService } from '../../services/source-code-excludes.service';
import { FormSourceCodeExcludeComponent } from '../../form/source-code-exclude/form-source-code-exclude.component';
import { ParamService } from '@monsido/core/param/param.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'admin-source-code-excludes',
    templateUrl: './source-code-excludes.component.html',
    standalone: false,
})
export class SourceCodeExcludesComponent extends BaseContainerComponentController implements OnInit {
    sourceCodeExcludes: any[] = [];
    tabs: any[] = [];
    promise: any;

    constructor (
        private paramService: ParamService,
        private sourceCodeExcludesApiService: SourceCodeExcludesApiService,
        private monEventService: MonEventService,
        private sourceCodeExcludesService: SourceCodeExcludesService,
        private translateService: TranslateService,
        private monModalService: MonModalService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.sourceCodeExcludes = [];
        this.tabs = this.sourceCodeExcludesService.getTabs();
        this.activeTab = this.sourceCodeExcludesService.getDefaultTab();
        this.getPage = this.getSourceCodeExcludesPage;
        this.getSourceCodeExcludesPage();
    }

    getSourceCodeExcludesPage (): void {
        this.paramService.setParams({
            page_size: this.pageSize,
            page: this.page,
        });

        this.getSourceCodeExcludes();
    }

    getSourceCodeExcludes (): void {
        const params = {
            page: this.page,
            page_size: this.pageSize,
        };
        this.promise = this.sourceCodeExcludesApiService.getAll(this.activeTab, params).then((excludes: any) => {
            this.sourceCodeExcludes = excludes;
            this.updateDropdowns();
        });
    }

    updateDropdowns (): void {
        for (const sourceCodeExclude of this.sourceCodeExcludes) {
            const dropdown = [
                {
                    label: this.translateService.getString('Edit'),
                    leftIcon: 'faCog',
                    action: () => this.openDialog(sourceCodeExclude),
                    eventParams: { action: 'source-code-exclude-edit' },
                },
                {
                    label: this.translateService.getString('Delete'),
                    leftIcon: 'faTrashAlt',
                    action: () => {
                        const message = this.translateService.getString('Are you sure you want to delete this source exclude?');
                        this.monModalService.confirm(message).then(() => this.deleteSourceCodeExclude(sourceCodeExclude));
                    },
                    eventParams: { action: 'source-code-exclude-delete' },
                },
            ];

            sourceCodeExclude.dropdown = dropdown.map(item => {
                return {
                    label: item.label,
                    leftIcon: item.leftIcon,
                    action: () => {
                        this.monEventService.run('actionTrigger', item.eventParams);
                        item.action();
                    },
                };
            });
        }
    }

    openDialog (sourceCodeExclude?: any): void {
        const params = {
            body: FormSourceCodeExcludeComponent,
            size: 'lg',
            data: {
                sourceCodeExclude: sourceCodeExclude,
                module: this.activeTab,
            },
        };
        const callback = (updatedSourceCodeExclude: any) => {
            if (typeof updatedSourceCodeExclude === 'object') {
                this.getSourceCodeExcludesPage();
            }
        };
        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback });
    }

    deleteSourceCodeExclude (sourceCodeExclude: any): void {
        this.sourceCodeExcludesApiService.destroy(this.activeTab, sourceCodeExclude).then(() => {
            this.getSourceCodeExcludesPage();
        });
    }

    isAccessibility (module: any): boolean {
        return this.sourceCodeExcludesService.isAccessibility(module);
    }

    trackBySourceCodeExclude (index: number, item: any): any {
        return item.id;
    }
}
